import ProductVarietiesForm from '@app/components/apps/ProductVarieties/ProductVarietiesForm';
import { ProductVarietiesTable } from '@app/components/apps/ProductVarieties/ProductVarietiesTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { CrudSettingsContext } from '@app/contexts/CrudSettingsContext';
import { CrudSettings } from '@app/models/CrudSettings';
import { Col, Row } from 'antd';
import { useState } from 'react';

const AllProductVarietiesPage = () => {
  const [settings, setSettings] = useState<CrudSettings>({
    mode: 'list',
    id: null,
  });

  const pageTitle = () => {
    switch (settings.mode) {
      case 'create':
        return 'Create Product Variety';
      case 'edit':
        return 'Edit Product Variety';
      case 'view':
        return 'View Product Variety';

      default:
        return 'Product Varieties';
    }
  };

  return (
    <>
      <PageTitle>Product Varieties</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BaseBreadcrumb
            routes={[
              {
                path: '/',
                breadcrumbName: 'Home',
              },
              {
                path: '/product-varieties',
                breadcrumbName: pageTitle(),
              },
            ]}
          />
        </Col>
        <Col span={24}>
          <CrudSettingsContext.Provider value={{ settings, setSettings }}>
            {settings.mode != 'list' ? (
              <ProductVarietiesForm pageTitle={pageTitle()} type={'create'} editable={false} />
            ) : (
              <ProductVarietiesTable />
            )}
          </CrudSettingsContext.Provider>
        </Col>
      </Row>
    </>
  );
};

export default AllProductVarietiesPage;
